/* Category-specific menu picks: only the named category/descendants, never the global catalog. */
(() => {
  const ready=new WeakSet();
  const shuffle=items=>{for(let i=items.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[items[i],items[j]]=[items[j],items[i]];}return items;};
  function choose(pool){
    const cards=[...pool.querySelectorAll('[data-vnk-category-pick]')];
    const selected=Math.floor(Math.random()*cards.length);
    // Keep the first server-rendered card until the random candidate is decoded.
    cards.forEach((card,i)=>card.hidden=i!==0);
    const reveal=()=>{if(pool.isConnected)cards.forEach((card,i)=>card.hidden=i!==selected);};
    const image=cards[selected]?.querySelector('img');
    if(image){
      image.loading='eager';image.fetchPriority='auto';
      const decoded=()=>{if(!image.naturalWidth)return;const promise=typeof image.decode==='function'?image.decode():Promise.resolve();promise.catch(()=>{}).then(reveal);};
      if(image.complete)decoded();else image.addEventListener('load',decoded,{once:true});
    }else reveal();
    pool.classList.toggle('vnk-picks-empty',!cards.length);
    return cards.length;
  }
  function init(root=document){
    root.querySelectorAll('[data-vnk-category-picks]').forEach(pool=>{
      if(ready.has(pool))return;ready.add(pool);
      if(choose(pool))return;
      let sources=[];
      try{sources=JSON.parse(pool.dataset.vnkCategorySources||'[]').filter(Boolean);}catch{return;}
      const menu=pool.closest('[data-vnk-category-menu]');if(!menu)return;
      let started=false;
      const load=async()=>{
        if(started)return;started=true;
        // The main collection usually contains all descendants. Only try children if it has no eligible item.
        const paths=[sources[0],...shuffle(sources.slice(1))].filter(Boolean);
        for(const source of paths){
          if(!pool.isConnected)return;
          const base=new URL(source,location.origin);
          if(base.origin!==location.origin || !/\/collections\/[^/]+\/?$/.test(base.pathname))continue;
          const batches=await Promise.all(['we-love','rare-find','rare-piece','bestseller','full-set'].map(async tag=>{
            const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),5000);
            try{
              const url=new URL(base);url.pathname=url.pathname.replace(/\/$/,'')+'/'+tag;
              url.search='';url.searchParams.set('section_id','vnk-category-menu-picks');url.searchParams.set('page','1');
              const response=await fetch(url,{credentials:'same-origin',signal:controller.signal});
              if(!response.ok)return [];
              const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
              const region=parsed.querySelector('[data-vnk-category-response]');
              return region?[...region.querySelectorAll('[data-vnk-category-pick]')]:[];
            }catch{return [];}finally{clearTimeout(timer);}
          }));
          const unique=new Map();
          batches.flat().forEach(card=>{
            const href=card.getAttribute('href');if(!href)return;
            const url=new URL(href,location.origin);
            const badge=card.querySelector('.vnk-mega-pick-badge')?.textContent.trim();
            if(url.origin===location.origin&&/\/products\//.test(url.pathname)&&['WE LOVE','RARE PIECE','RARE FIND','BESTSELLER','FULL SET'].includes(badge))unique.set(url.pathname,card);
          });
          if(unique.size && pool.isConnected){pool.replaceChildren(...unique.values());choose(pool);return;}
        }
      };
      menu.addEventListener('pointerenter',load,{once:true});
      menu.addEventListener('focusin',load,{once:true});
      // Warm missing category picks after the page's initial render, before hover.
      if('requestIdleCallback' in window)requestIdleCallback(load,{timeout:1800});
      else setTimeout(load,1000);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
